import { Link } from "@remix-run/react";

import { Logo } from "~/components/common/Logo/Logo";

interface LoginCardProps {
  children: React.ReactNode;
  title: string;
}

const LoginCard = ({ children, title }: LoginCardProps) => (
  <div className="flex min-h-svh w-full flex-1 items-center overflow-x-hidden md:h-auto md:min-h-screen">
    <div className="w-full p-2">
      <div className="mx-auto flex w-full max-w-lg flex-col overflow-hidden rounded-lg bg-white shadow-lg dark:bg-gray-800 md:min-h-[300px] md:max-w-2xl md:flex-row lg:max-w-4xl">
        <div className="relative flex h-36 items-center justify-center bg-cover p-4 md:h-auto md:w-4/5 lg:w-1/2">
          <div className="absolute left-0 top-0 z-0 size-full bg-purple"></div>
          <Link to={"/"}>
            <Logo color="teal" className="relative z-[1] h-auto w-[240px]" />
          </Link>
        </div>

        <div className="w-full flex-col justify-between px-6 py-8 md:flex md:px-8 lg:w-1/2">
          <div>
            <p className="mt-3 text-center text-xl text-gray-600 dark:text-gray-200">
              {title}
            </p>
          </div>
          <div>{children}</div>
        </div>
      </div>
    </div>
  </div>
);

export default LoginCard;
